import { render } from "./PrintQueue.vue?vue&type=template&id=8c5639a2"
import script from "./PrintQueue.vue?vue&type=script&lang=js"
export * from "./PrintQueue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__